exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "video {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    min-width: 100%;\n    min-height: 100%;\n    width: auto;\n    height: auto;\n    z-index: -100;\n    -webkit-transform: translateX(-50%) translateY(-50%);\n            transform: translateX(-50%) translateY(-50%);\n    background: url(" + require("../../../assets/images/login/bg.png") + ") no-repeat;\n    background-size: cover;\n    transition: 1s opacity;\n}\n\n.rowBody {\n    position: fixed;\n    /* width: 100%; */\n    top: 0px;\n    right: 0;\n    left: 0;\n    height: 100%;\n    background-color: rgba(14, 46, 71, 0.8) !important;\n    overflow-y: auto;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/app/pages/org-login/org-login.component.css
// module id = ../../../../../src/app/pages/org-login/org-login.component.css
// module chunks = main